<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
            <v-toolbar flat>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="subheading" v-if="!newBusCls">
                      {{ busClsTitle }}
                    </v-list-tile-title>
                    <v-list-tile-title class="subheading" v-else>
                      New Business Class
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-toolbar>
            <v-list class="pt-0">
              <v-divider></v-divider>
              <v-list-tile key="cargoBusClsGeneral" :to="{ name: 'cargoBusClsGeneral', params: { id: id } }">
                <v-list-tile-action>
                  <v-icon></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>General</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-group v-if="!newBusCls">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-icon></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Claim</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="item in claimMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <v-list-group v-if="(!newBusCls && tariffList.length > 0)">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-icon></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Tariff</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="item in tariffList" :key="item.label" @click="passTariffValue(item)">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title :class="isMatchRoute('cargoBusClsTariff') && item.active ? 'primary--text':''">{{ item.label }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!-- <v-list-group v-if="(!newBusCls && coverList.length > 0)">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-icon></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Coverage</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="item in coverList" :key="item.label" @click="passCoverValue(item)">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title :class="isMatchRoute('cargoBusClsCover') && item.active ? 'primary--text':''">{{ item.label }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group> -->
              <template v-if="!newBusCls">
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view @resetSideMenu="resetSideMenu"></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import routeMixin from '@/mixins/route'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { appID } from '@/const/underwriting'
import { PARAMETERS_APPID } from '@/store/types'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      sideMenu: [
        { name: 'cargoProdBusCls', text: 'Product', icon: '' }
      ],
      claimMenu: [
        { name: 'cargoBusClsClmNol1', text: 'Nature of Loss', icon: '' },
        { name: 'cargoBusClsClmResCat', text: 'Reserve Category', icon: '' }
      ],
      covers: [],
      coverMenu: [],
      tariff: [],
      tariffMenu: [],
      selectedCovers: [],
      newBusCls: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    busClsState() {
      return this.$store.state.parameters.busCls
    },
    busClsTitle() {
      return this.$store.state.parameters.busCls.busClsMenu.sideMenuTitle
    },
    coverList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsCoverList
    },
    tariffList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsTarfList
    }
  },
  methods: {
    async doInit() {
      this.$store.commit(PARAMETERS_APPID, appID.CARGO)
      if (this.id === 'new') {
        this.newBusCls = true
      } else {
        await this.$store.dispatch('busClsMenuInit', this.id)
        this.sideMenu.push({ name: 'cargoBusClsClause', text: 'Clauses' })
        this.coverMenu = this.coverList
        this.tariffMenu = this.tariffList
      }
    },
    async doCoverInit() {
      const apiURI = this.busClsState.menuList.busClsCovers
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            if (this.covers.length > 0) {
              this.covers = []
              data.map((cover) => {
                this.covers.push({ label: cover.cvrType + ' - ' + cover.cvrTypeDesc, value: cover.cvrType, disabled: true })
              })
            } else {
              data.map((cover) => {
                this.covers.push({ label: cover.cvrType + ' - ' + cover.cvrTypeDesc, value: cover.cvrType, disabled: true })
              })
            }
            if (this.coverMenu.length > 0) {
              var onlyInCover = this.coverMenu.filter(this.comparer(this.covers))
              var onlyInSelected = this.covers.filter(this.comparer(this.coverMenu))
              const result = onlyInCover.concat(onlyInSelected)
              result.forEach(item => {
                this.coverMenu.push({ name: 'cargoBusClsCover', text: item.label, icon: '', params: { cover: item.value } })
              })
            } else {
              this.covers.forEach(item => {
                this.coverMenu.push({ name: 'cargoBusClsCover', text: item.label, icon: '', params: { cover: item.value } })
              })
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    async doTariffInit() {
      const apiURI = this.busClsState.menuList.busClsTariffs
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            if (this.tariff.length > 0) {
              this.tariff = []
              data.map((tariff) => {
                this.tariff.push({ label: tariff.tarf + ' - ' + tariff.tarfDesc, value: tariff.tarf, disabled: true })
              })
            } else {
              data.map((tariff) => {
                this.tariff.push({ label: tariff.tarf + ' - ' + tariff.tarfDesc, value: tariff.tarf, disabled: true })
              })
            }
            if (this.tariffMenu.length > 0) {
              var onlyInTariff = this.tariffMenu.filter(this.comparer(this.tariff))
              var onlyInSelected = this.tariff.filter(this.comparer(this.tariffMenu))
              const result = onlyInTariff.concat(onlyInSelected)
              result.forEach(item => {
                this.tariffMenu.push({ name: 'cargoBusClsTariff', text: item.label, icon: '', params: { tariff: item.value } })
              })
            } else {
              this.tariff.forEach(item => {
                this.tariffMenu.push({ name: 'cargoBusClsTariff', text: item.label, icon: '', params: { tariff: item.value } })
              })
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    comparer(otherArray) {
      return function (current) {
        return otherArray.filter(function (other) {
          if (otherArray.label != null) {
            return other.label === current.text
          } else {
            return current.label === other.text
          }
        }).length === 0
      }
    },
    passCoverValue(item) {
      // sideMenu color
      this.coverMenu.forEach(data => {
        data.active = false
      })
      item.active = true
      this.$router.push({ name: 'cargoBusClsCover', params: { cover: item.value } })
    },
    passTariffValue(item) {
      // sideMenu color
      this.tariffMenu.forEach(data => {
        data.active = false
      })
      item.active = true
      this.$router.push({ name: 'cargoBusClsTariff', params: { tariff: item.value } })
    },
    async resetSideMenu() {
      await this.doInit()
    }
  },
  created() {
    if (this.id === 'new') {
      this.newBusCls = true
    }
  },
  mixins: [
    routeMixin,
    MessageMixin
  ],
  props: ['id']
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
</style>
